/* ============================================================
   Carta Noor — Panel Configurator

   POSTS TO /cart/add.js ITSELF: both theme add-to-cart handlers
   build their payload by hand from `id` and `quantity` only, so
   properties[] on the form are silently discarded.

   PANEL LENGTH IS CHOSEN FOR THE CUSTOMER:
   Fancy Walls print 30 in wide in several lengths. The store now
   carries 96 / 108 / 120 / 144 in. The configurator reads the wall
   height, adds TRIM_ALLOWANCE, and picks the SHORTEST panel that
   covers it — so a 2.6 m wall no longer buys a 3.05 m panel and
   bins 45 cm of it. The customer can override either way.

   Walls of different heights need different panel lengths, so the
   cart receives one line item per length.

   NOTE FOR MAINTAINERS: this file is deployed through a GraphQL
   block string, which passes backslashes through literally. Keep
   it entirely free of backslashes — no regex escapes, no \\u
   sequences — or they arrive doubled and silently break.
   ============================================================ */
(function () {
  'use strict';

  /* Localised UI strings come from window.CN_T (rendered in layout/theme.liquid
     from locales/*.json). The English fallback keeps this file working alone. */
  var CN_T = window.CN_T || {};
  function tx(k, fb, v) {
    var s = CN_T[k] || fb;
    if (v) { Object.keys(v).forEach(function (n) { s = s.split('{' + n + '}').join(String(v[n])); }); }
    return s;
  }

  var dataEl = document.getElementById('CNCfgData');
  if (!dataEl) return;

  var CFG;
  try { CFG = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.variants || !CFG.variants.length) return;

  var modal  = document.getElementById('CNCfgModal');
  var atcRow = document.querySelector('.cn-atc-row');
  var qtyIn  = document.getElementById('CNQty');
  var form   = document.querySelector('form[action*="/cart/add"]');
  if (!modal || !atcRow) return;

  var CM_IN = 2.54;
  var PANEL_W = Number(CFG.panelW) > 0 ? Number(CFG.panelW) : 76;
  var ASPECT  = Number(CFG.tileAspect) > 0 ? Number(CFG.tileAspect) : 1;
  var IS_MURAL = CFG.renderMode === 'mural';
  var HAS_TILE = !!CFG.tile;

  var FIT_STRETCH = 1.30;   /* max artwork stretch before cropping   */
  var TRIM_ALLOWANCE = 5;   /* cm of panel length kept for trimming  */

  function isSample(s) { return String(s || '').toLowerCase().indexOf('sample') >= 0; }
  /* "108 in / 274 cm" -> 274. No regex: block-string deploy forbids backslashes. */
  function cmOf(sizeLabel) {
    var parts = String(sizeLabel || '').split('/');
    return parseFloat(parts[parts.length - 1]) || 0;
  }

  var PANEL_VARIANTS = [];
  CFG.variants.forEach(function (v) {
    if (isSample(v.type) || isSample(v.size)) return;
    v.cm = cmOf(v.size);
    if (v.cm > 0) PANEL_VARIANTS.push(v);
  });
  if (!PANEL_VARIANTS.length) return;

  var TYPES = [];
  PANEL_VARIANTS.forEach(function (v) { if (TYPES.indexOf(v.type) < 0) TYPES.push(v.type); });

  var SIZES = [];
  PANEL_VARIANTS.forEach(function (v) {
    for (var i = 0; i < SIZES.length; i++) if (SIZES[i].key === v.size) return;
    SIZES.push({ key: v.size, cm: v.cm });
  });
  SIZES.sort(function (a, b) { return a.cm - b.cm; });

  function findVariant(type, sizeKey) {
    for (var i = 0; i < PANEL_VARIANTS.length; i++) {
      if (PANEL_VARIANTS[i].type === type && PANEL_VARIANTS[i].size === sizeKey) return PANEL_VARIANTS[i];
    }
    return null;
  }
  function autoSize(hCm) {
    var need = hCm + TRIM_ALLOWANCE;
    for (var i = 0; i < SIZES.length; i++) if (SIZES[i].cm >= need) return SIZES[i];
    return SIZES[SIZES.length - 1];
  }

  var SCALE_META = {
    /* en = English label, kept for the line-item properties the supplier reads */
    '1:1': { v: 1, en: 'Original scale (1:1)', label: tx('s11_label', 'Original scale (1:1)'),
             note: tx('s11_note', 'The design fills your wall once, edge to edge, exactly as drawn.') },
    '1:2': { v: 2, en: 'Reduced (1:2)', label: tx('s12_label', 'Reduced (1:2)'),
             note: tx('s12_note', 'Half size, so the design repeats twice across and twice down.') },
    '1:4': { v: 4, en: 'Reduced (1:4)', label: tx('s14_label', 'Reduced (1:4)'),
             note: tx('s14_note', 'Quarter size — sixteen repeats. Reads as texture rather than a scene.') }
  };
  var allowed = (CFG.scales && CFG.scales.length) ? CFG.scales : ['1:1', '1:2', '1:4'];
  var SCALES = allowed.filter(function (k) { return SCALE_META[k]; })
    .map(function (k) { var m = SCALE_META[k]; return { key: k, v: m.v, label: m.label, en: m.en, note: m.note }; });
  if (!SCALES.length) SCALES = [{ key: '1:1', v: 1, label: tx('s11_label', 'Original scale (1:1)'), en: 'Original scale (1:1)', note: '' }];

  var state = {
    scale: IS_MURAL ? 1 : SCALES[0].v,
    type: TYPES[0],
    unit: 'cm',
    view: 'wall',
    panels: true,
    ruler: true,
    walls: [{ w: 240, h: 260, extra: 0, size: null }]
  };

  function toCm(v) { return state.unit === 'in' ? v * CM_IN : v; }
  function fromCm(v) { return state.unit === 'in' ? v / CM_IN : v; }
  function fmtLen(cm) { return (Math.round(fromCm(cm) * 10) / 10) + ' ' + state.unit; }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(subunits) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency', currency: CFG.currency, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0
      }).format(subunits / 100);
    } catch (e) { return (subunits / 100).toFixed(0) + ' ' + CFG.currency; }
  }
  function effScale() { return IS_MURAL ? 1 : state.scale; }
  function scaleKey() {
    for (var i = 0; i < SCALES.length; i++) if (SCALES[i].v === state.scale) return SCALES[i];
    return SCALES[0];
  }

  function wallSize(wl) {
    var h = toCm(wl.h);
    if (!(h > 0)) return SIZES[0];
    if (wl.size) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].key === wl.size) return SIZES[i]; }
    return autoSize(h);
  }
  function minCols(wl) { var w = toCm(wl.w); return w > 0 ? Math.ceil(w / PANEL_W) : 0; }
  function wallCols(wl) { var m = minCols(wl); return m ? m + Math.max(0, Math.min(wl.extra || 0, 4)) : 0; }
  function wallRows(wl) { var h = toCm(wl.h), s = wallSize(wl); return h > 0 ? Math.ceil(h / s.cm) : 0; }

  function calc() {
    var cols = 0, rows = 0, panels = 0, area = 0, paper = 0, total = 0, groups = {};
    state.walls.forEach(function (wl) {
      var w = toCm(wl.w), h = toCm(wl.h);
      if (!(w > 0 && h > 0)) return;
      var c = wallCols(wl), r = wallRows(wl), s = wallSize(wl);
      var v = findVariant(state.type, s.key);
      cols += c; rows = Math.max(rows, r); panels += c * r;
      area += w * h;
      paper += c * PANEL_W * r * s.cm;
      if (v) {
        total += c * r * v.price;
        if (!groups[s.key]) groups[s.key] = { size: s, variant: v, qty: 0 };
        groups[s.key].qty += c * r;
      }
    });
    return { cols: cols, rows: rows, panels: panels, areaCm: area, paperCm: paper,
             total: total, groups: groups, waste: paper > 0 ? (paper - area) / paper : 0 };
  }

  function fitBox(targetW, targetH) {
    var need = targetW / targetH, have = ASPECT;
    var lo = have / FIT_STRETCH, hi = have * FIT_STRETCH;
    var used = Math.max(lo, Math.min(need, hi));
    var stretch = used / have, cropped = Math.abs(used - need) > 0.0001;
    var bw, bh, bx, by;
    if (!cropped) { bw = targetW; bh = targetH; bx = 0; by = 0; }
    else if (used > need) { bh = targetH; bw = targetH * used; bx = (targetW - bw) / 2; by = 0; }
    else { bw = targetW; bh = targetW / used; bx = 0; by = (targetH - bh) / 2; }
    return { w: bw, h: bh, x: bx, y: by, stretch: stretch, cropped: cropped };
  }
  function fitLabel(f) {
    var pct = Math.round(Math.abs(f.stretch - 1) * 100);
    if (f.cropped) return tx('fit_cropped', 'stretched to the limit, edges cropped');
    if (pct <= 1) return tx('fit_exact', 'fits exactly, nothing lost');
    return tx('fit_stretched', 'stretched {pct}% to fit — whole design visible', { pct: pct });
  }
  function wallFit(wl) {
    var w = toCm(wl.w) || 240, h = toCm(wl.h) || 260, n = effScale();
    return fitBox(w / n, h / n);
  }

  function noteText() {
    if (!HAS_TILE) return tx('no_art', 'No artwork is available for this design, so the wall is drawn plain.');
    var f = wallFit(state.walls[0] || { w: 240, h: 260 });
    if (IS_MURAL) {
      return tx('mural_note', 'This design is a mural — printed once across your wall as one continuous scene, ' +
             'gently stretched to your proportions so nothing is cropped. Here: {fit}.', { fit: fitLabel(f) });
    }
    if (effScale() === 1) {
      return tx('orig_note', 'At original scale the design is printed once across your wall — it does not repeat. ' +
             'Here: {fit}.', { fit: fitLabel(f) });
    }
    var n = effScale();
    return tx('repeat_note', 'At 1:{n} the design repeats {n} times across and {n} down. Joins may ' +
           'not align perfectly until a seamless tile is supplied for this design.', { n: n });
  }

  function render() {
    var host = document.getElementById('CNCfgView');
    var note = document.getElementById('CNCfgNote');
    if (!host) return;

    var wl = state.walls[0] || { w: 0, h: 0, extra: 0, size: null };
    var W = toCm(wl.w) || 240, H = toCm(wl.h) || 260;
    var n = effScale(), cols = wallCols(wl) || Math.ceil(W / PANEL_W);
    var s = wallSize(wl), rows = wallRows(wl) || 1;

    if (note) { var t = noteText(); note.hidden = !t; note.textContent = t; }

    if (state.view === 'pattern') {
      if (!HAS_TILE) {
        host.innerHTML = '<svg viewBox="0 0 300 300"><rect width="300" height="300" fill="#1A1A20"/>' +
          '<text x="150" y="150" font-family="monospace" font-size="13" fill="#7C7669" ' +
          'text-anchor="middle">' + esc(tx('no_art_svg', 'no artwork available')) + '</text></svg>';
        return;
      }
      var ph = 100 / ASPECT;
      host.innerHTML = '<svg viewBox="0 0 100 ' + ph + '" preserveAspectRatio="xMidYMid meet">' +
        '<image href="' + esc(CFG.tile) + '" x="0" y="0" width="100" height="' + ph +
        '" preserveAspectRatio="xMidYMid meet"/></svg>';
      return;
    }

    var padL = state.ruler ? 48 : 12, padT = state.ruler ? 42 : 12, padB = 70, padR = 12;
    var vbW = W + padL + padR, vbH = H + padT + padB;
    var tileW = W / n, tileH = H / n, f = fitBox(tileW, tileH);

    var s2 = '<svg viewBox="0 0 ' + vbW + ' ' + vbH + '" preserveAspectRatio="xMidYMid meet">' +
             '<defs><clipPath id="cnc-artclip"><rect x="' + padL + '" y="' + padT +
             '" width="' + W + '" height="' + H + '"/></clipPath></defs>' +
             '<rect width="' + vbW + '" height="' + vbH + '" fill="#0E0E11"/>' +
             '<rect x="' + padL + '" y="' + padT + '" width="' + W + '" height="' + H + '" fill="#1A1A20"/>';

    if (HAS_TILE) {
      s2 += '<g clip-path="url(#cnc-artclip)">';
      for (var ry = 0; ry < n; ry++) {
        for (var rx = 0; rx < n; rx++) {
          s2 += '<image href="' + esc(CFG.tile) + '" x="' + (padL + rx * tileW + f.x) + '" y="' +
                (padT + ry * tileH + f.y) + '" width="' + f.w + '" height="' + f.h +
                '" preserveAspectRatio="none"/>';
        }
      }
      s2 += '</g>';
    }

    if (n > 1) {
      for (var i = 1; i < n; i++) {
        s2 += '<line x1="' + (padL + i * tileW) + '" y1="' + padT + '" x2="' + (padL + i * tileW) +
              '" y2="' + (padT + H) + '" stroke="#EFE9DC" stroke-width="0.8" opacity=".22"/>' +
              '<line x1="' + padL + '" y1="' + (padT + i * tileH) + '" x2="' + (padL + W) +
              '" y2="' + (padT + i * tileH) + '" stroke="#EFE9DC" stroke-width="0.8" opacity=".22"/>';
      }
    }

    s2 += '<rect x="' + padL + '" y="' + (padT + H) + '" width="' + W + '" height="7" fill="#EFE9DC" opacity=".8"/>' +
          '<rect x="0" y="' + (padT + H + 7) + '" width="' + vbW + '" height="' + (padB - 7) + '" fill="#16161A"/>';

    if (W > 150) {
      var fx = padL + W - 62, fy = padT + H, fh = 170, hr = fh * 0.052;
      var limbs =
        '<line x1="' + fx + '" y1="' + (fy - fh + hr * 2) + '" x2="' + fx + '" y2="' + (fy - fh * 0.42) + '"/>' +
        '<line x1="' + fx + '" y1="' + (fy - fh * 0.78) + '" x2="' + (fx - fh * 0.13) + '" y2="' + (fy - fh * 0.52) + '"/>' +
        '<line x1="' + fx + '" y1="' + (fy - fh * 0.78) + '" x2="' + (fx + fh * 0.13) + '" y2="' + (fy - fh * 0.52) + '"/>' +
        '<line x1="' + fx + '" y1="' + (fy - fh * 0.42) + '" x2="' + (fx - fh * 0.10) + '" y2="' + fy + '"/>' +
        '<line x1="' + fx + '" y1="' + (fy - fh * 0.42) + '" x2="' + (fx + fh * 0.10) + '" y2="' + fy + '"/>';
      s2 += '<g opacity=".55" fill="none" stroke="#0E0E11" stroke-width="5.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="' + fx + '" cy="' + (fy - fh + hr) + '" r="' + (hr + 1.4) + '" fill="#0E0E11" stroke="none"/>' + limbs + '</g>' +
            '<g opacity=".92" fill="none" stroke="#EFE9DC" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="' + fx + '" cy="' + (fy - fh + hr) + '" r="' + hr + '" fill="#EFE9DC" stroke="none"/>' + limbs + '</g>' +
            '<text x="' + fx + '" y="' + (fy - fh - 10) + '" font-family="monospace" font-size="14" ' +
            'fill="#EFE9DC" text-anchor="middle" opacity=".85">1.7 m</text>';
    }

    if (state.panels) {
      var k, seamX;
      for (k = 1; k < cols; k++) {
        seamX = padL + k * PANEL_W;
        if (seamX >= padL + W - 0.5) break;
        s2 += '<line x1="' + seamX + '" y1="' + padT + '" x2="' + seamX + '" y2="' + (padT + H) +
              '" stroke="#0E0E11" stroke-width="3.6" opacity=".5"/>' +
              '<line x1="' + seamX + '" y1="' + padT + '" x2="' + seamX + '" y2="' + (padT + H) +
              '" stroke="#B08A46" stroke-width="1.6" opacity=".95"/>';
      }
      for (k = 1; k < rows; k++) {
        var y = padT + k * s.cm;
        if (y >= padT + H - 0.5) break;
        s2 += '<line x1="' + padL + '" y1="' + y + '" x2="' + (padL + W) + '" y2="' + y +
              '" stroke="#0E0E11" stroke-width="3.6" opacity=".5"/>' +
              '<line x1="' + padL + '" y1="' + y + '" x2="' + (padL + W) + '" y2="' + y +
              '" stroke="#B08A46" stroke-width="1.6" opacity=".95" stroke-dasharray="10 7"/>';
      }
      for (k = 0; k < cols; k++) {
        var cw = Math.min(PANEL_W, W - k * PANEL_W);
        if (cw <= 1) break;
        var lx = padL + k * PANEL_W + cw / 2;
        s2 += '<rect x="' + (lx - 11) + '" y="' + (padT + 6) + '" width="22" height="19" fill="#0E0E11" opacity=".75"/>' +
              '<text x="' + lx + '" y="' + (padT + 19) + '" font-family="monospace" font-size="13" ' +
              'fill="#B08A46" text-anchor="middle">' + (k + 1) + '</text>';
      }
    }

    s2 += '<rect x="' + padL + '" y="' + padT + '" width="' + W + '" height="' + H +
          '" fill="none" stroke="#33323A" stroke-width="1.4"/>';

    if (state.ruler) {
      s2 += '<g stroke="#7C7669" stroke-width="1.2" font-family="monospace" font-size="14" fill="#B08A46">' +
        '<line x1="' + padL + '" y1="' + (padT - 17) + '" x2="' + (padL + W) + '" y2="' + (padT - 17) + '"/>' +
        '<line x1="' + padL + '" y1="' + (padT - 22) + '" x2="' + padL + '" y2="' + (padT - 12) + '"/>' +
        '<line x1="' + (padL + W) + '" y1="' + (padT - 22) + '" x2="' + (padL + W) + '" y2="' + (padT - 12) + '"/>' +
        '<text x="' + (padL + W / 2) + '" y="' + (padT - 24) + '" text-anchor="middle" stroke="none">' + fmtLen(W) + '</text>' +
        '<line x1="' + (padL - 21) + '" y1="' + padT + '" x2="' + (padL - 21) + '" y2="' + (padT + H) + '"/>' +
        '<line x1="' + (padL - 26) + '" y1="' + padT + '" x2="' + (padL - 16) + '" y2="' + padT + '"/>' +
        '<line x1="' + (padL - 26) + '" y1="' + (padT + H) + '" x2="' + (padL - 16) + '" y2="' + (padT + H) + '"/>' +
        '<text x="' + (padL - 28) + '" y="' + (padT + H / 2) + '" text-anchor="middle" stroke="none" ' +
        'transform="rotate(-90 ' + (padL - 28) + ' ' + (padT + H / 2) + ')">' + fmtLen(H) + '</text></g>';
    }

    host.innerHTML = s2 + '</svg>';
  }

  function refreshWallMeta() {
    var host = document.getElementById('CNCfgWalls');
    state.walls.forEach(function (wl, i) {
      var row = host.querySelector('[data-row="' + i + '"]');
      if (!row) return;
      var wcm = toCm(wl.w), hcm = toCm(wl.h);
      var m = minCols(wl), c = wallCols(wl), s = wallSize(wl), rows = wallRows(wl) || 1;
      var auto = hcm > 0 ? autoSize(hcm) : SIZES[0];
      var trimW = Math.max(0, c * PANEL_W - wcm), trimH = Math.max(0, rows * s.cm - hcm);

      var num = row.querySelector('[data-num]'); if (num) num.textContent = c;
      var dec = row.querySelector('[data-dec]'); if (dec) dec.disabled = (c <= m);
      var inc = row.querySelector('[data-inc]'); if (inc) inc.disabled = ((wl.extra || 0) >= 4);

      var sizeSel = row.querySelector('[data-size]');
      if (sizeSel && sizeSel.value !== s.key) sizeSel.value = s.key;

      var pick = row.querySelector('[data-pick]');
      if (pick) {
        if (!(hcm > 0)) { pick.textContent = ''; }
        else if (wl.size && wl.size !== auto.key) {
          pick.innerHTML = tx('pick_warn', 'Your choice. We would pick <b>{key}</b> for a {len} wall.', { key: esc(auto.key), len: fmtLen(hcm) });
          pick.className = 'cnc-fit warn';
        } else {
          pick.innerHTML = tx('pick_ok', 'Shortest length covering {len} plus {trim} to trim. <b>{cut}</b> comes off the length.',
                              { len: fmtLen(hcm), trim: fmtLen(TRIM_ALLOWANCE), cut: fmtLen(trimH) });
          pick.className = 'cnc-fit';
        }
      }

      var cov = row.querySelector('[data-cov]');
      if (cov) {
        if (!(wcm > 0 && hcm > 0)) { cov.textContent = ''; cov.className = 'cnc-cov'; }
        else {
          var bits = [c > 1 ? tx('cov_other', '{c} panels across cover {len}', { c: c, len: fmtLen(c * PANEL_W) })
                            : tx('cov_one', '{c} panel across covers {len}', { c: c, len: fmtLen(c * PANEL_W) })];
          if (trimW > 0.5) bits.push(tx('cov_trim', '{len} trimmed from the last panel', { len: fmtLen(trimW) }));
          cov.innerHTML = bits.join(' · ');
          cov.className = 'cnc-cov' + (trimW < 0.5 ? ' exact' : '');
        }
      }
      var res = row.querySelector('[data-auto]');
      if (res) res.hidden = !(wl.extra > 0 || wl.size);
    });
  }

  function update() {
    var r = calc(), sk = scaleKey(), n = effScale();
    var $ = function (id) { return document.getElementById(id); };

    var rl = $('CNCfgRepeat');
    if (rl) rl.textContent = IS_MURAL ? '' : (n === 1 ? tx('fills_wall', 'fills the wall') : tx('repeats', '{n} × {n} repeats', { n: n }));

    if (r.panels > 0) {
      var sizeNames = Object.keys(r.groups).map(function (k) { return r.groups[k].qty + ' × ' + k; }).join(' + ');
      $('CNCfgHero').innerHTML = r.panels > 1
        ? tx('hero_other', '<em>{n}</em> panels of {w} cm wide', { n: r.panels, w: PANEL_W })
        : tx('hero_one', '<em>{n}</em> panel of {w} cm wide', { n: r.panels, w: PANEL_W });
      $('CNCfgHeroSub').textContent = state.type + ' · ' + sizeNames;
      $('CNCfgArea').textContent  = (Math.round(r.areaCm / 1000) / 10) + ' m²';
      $('CNCfgCov').textContent   = (Math.round(r.paperCm / 1000) / 10) + ' m²';
      $('CNCfgWaste').textContent = Math.round(r.waste * 100) + '%';
      $('CNCfgScale').textContent = IS_MURAL ? tx('scale_mural', 'Mural — spans the wall')
        : (n === 1 ? tx('scale_orig', 'Original (1:1) — no repeat') : sk.label + ' — ' + n + ' × ' + n);
      $('CNCfgTotal').textContent = money(r.total);
      $('CNCfgSubmit').disabled = false;
      $('CNCfgSubmit').textContent = r.panels > 1 ? tx('add_n_other', 'Add {n} panels to cart', { n: r.panels }) : tx('add_n_one', 'Add {n} panel to cart', { n: r.panels });
    } else {
      $('CNCfgHero').textContent = '—';
      $('CNCfgHeroSub').textContent = tx('enter_size', 'Enter your wall size.');
      ['CNCfgArea', 'CNCfgCov', 'CNCfgWaste', 'CNCfgScale', 'CNCfgTotal'].forEach(function (id) {
        $(id).textContent = '—';
      });
      $('CNCfgSubmit').disabled = true;
      $('CNCfgSubmit').textContent = tx('add_to_cart', 'Add to cart');
    }

    var warns = [];
    if (r.waste > 0.30) {
      warns.push(tx('warn_offcut', 'Offcut is {pct}%. Panels are a fixed {w} cm wide, so what does not fit is trimmed away.',
                    { pct: Math.round(r.waste * 100), w: PANEL_W }));
    }
    state.walls.forEach(function (wl, i) {
      var h = toCm(wl.h), s = wallSize(wl);
      if (h > 0 && h > s.cm) {
        warns.push(tx('warn_tall', 'Wall {i} is taller than the {key} panel — it needs a second ' +
                   'row and a horizontal seam. A longer panel would avoid that.', { i: i + 1, key: s.key }));
      }
      if (HAS_TILE && toCm(wl.w) > 0 && wallFit(wl).cropped) {
        warns.push(tx('warn_crop', 'Wall {i} is far from the artwork proportions, so its edges are cropped.', { i: i + 1 }));
      }
    });
    $('CNCfgWarn').innerHTML = warns.join('<br>');

    refreshWallMeta();
    render();
  }

  function buildScales() {
    var grp = document.getElementById('CNCfgScaleGrp');
    if (IS_MURAL) { if (grp) grp.hidden = true; return; }
    var host = document.getElementById('CNCfgScales');
    host.innerHTML = SCALES.map(function (s) {
      return '<label class="cnc-rad' + (s.v === state.scale ? ' is-on' : '') + '">' +
        '<input type="radio" name="cncScale" value="' + s.v + '"' + (s.v === state.scale ? ' checked' : '') + '>' +
        '<span><span class="cnc-rad__l">' + esc(s.label) + '</span>' +
        '<span class="cnc-rad__n">' + esc(s.note) + '</span></span></label>';
    }).join('');
    host.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('change', function () { state.scale = +this.value; buildScales(); update(); });
    });
  }

  function buildFinishes() {
    var host = document.getElementById('CNCfgFinishes');
    var s = wallSize(state.walls[0] || { h: 260 });
    host.innerHTML = TYPES.map(function (t) {
      var v = findVariant(t, s.key);
      return '<label class="cnc-rad' + (t === state.type ? ' is-on' : '') + '">' +
        '<input type="radio" name="cncFin" value="' + esc(t) + '"' + (t === state.type ? ' checked' : '') + '>' +
        '<span><span class="cnc-rad__l">' + esc(t) + '</span>' +
        '<span class="cnc-rad__p">' + (v ? tx('per_panel', '{price} per panel at {key}', { price: money(v.price), key: esc(s.key) }) : '—') +
        '</span></span></label>';
    }).join('');
    host.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('change', function () { state.type = this.value; buildFinishes(); update(); });
    });
  }

  function buildWalls() {
    var host = document.getElementById('CNCfgWalls');
    var opts = SIZES.map(function (s) {
      return '<option value="' + esc(s.key) + '">' + esc(s.key) + '</option>';
    }).join('');
    host.innerHTML = state.walls.map(function (w, i) {
      return '<div class="cnc-wall" data-row="' + i + '"><div class="cnc-wall__h">' +
        '<span class="cnc-wall__n">' + esc(tx('wall_n', 'Wall {i}', { i: i + 1 })) + '</span>' +
        (state.walls.length > 1 ? '<button type="button" class="cnc-wall__x" data-del="' + i +
          '" aria-label="' + esc(tx('remove_wall', 'Remove wall')) + '">×</button>' : '') +
        '</div><div class="cnc-dims">' +
        '<div class="cnc-fld"><label>' + esc(tx('width', 'Width ({u})', { u: state.unit })) + '</label>' +
        '<input type="number" min="0" step="1" inputmode="decimal" data-i="' + i + '" data-k="w" value="' + w.w + '"></div>' +
        '<div class="cnc-fld"><label>' + esc(tx('height', 'Height ({u})', { u: state.unit })) + '</label>' +
        '<input type="number" min="0" step="1" inputmode="decimal" data-i="' + i + '" data-k="h" value="' + w.h + '"></div>' +
        '</div>' +
        '<span class="cnc-steplbl">' + esc(tx('lbl_length', 'Panel length · chosen for your wall')) + '</span>' +
        '<select class="cnc-sizesel" data-size="' + i + '">' + opts + '</select>' +
        '<div class="cnc-fit" data-pick></div>' +
        '<span class="cnc-steplbl">' + esc(tx('lbl_across', 'Panels across · spares only')) + '</span>' +
        '<div class="cnc-step">' +
          '<button type="button" data-dec="' + i + '" aria-label="' + esc(tx('fewer', 'Fewer panels')) + '">−</button>' +
          '<span data-num>0</span>' +
          '<button type="button" data-inc="' + i + '" aria-label="' + esc(tx('more', 'More panels')) + '">+</button>' +
        '</div>' +
        '<div class="cnc-cov" data-cov></div>' +
        '<button type="button" class="cnc-auto" data-auto="' + i + '" hidden>' + esc(tx('back_reco', 'Back to our recommendation')) + '</button>' +
        '</div>';
    }).join('');

    host.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var i = +this.dataset.i;
        state.walls[i][this.dataset.k] = parseFloat(this.value) || 0;
        if (this.dataset.k === 'h') state.walls[i].size = null;
        update(); buildFinishes();
      });
    });
    host.querySelectorAll('[data-size]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        state.walls[+this.dataset.size].size = this.value; update(); buildFinishes();
      });
    });
    host.querySelectorAll('[data-del]').forEach(function (b) {
      b.addEventListener('click', function () { state.walls.splice(+this.dataset.del, 1); buildWalls(); update(); });
    });
    host.querySelectorAll('[data-dec]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wl = state.walls[+this.dataset.dec]; wl.extra = Math.max(0, (wl.extra || 0) - 1); update();
      });
    });
    host.querySelectorAll('[data-inc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wl = state.walls[+this.dataset.inc]; wl.extra = Math.min(4, (wl.extra || 0) + 1); update();
      });
    });
    host.querySelectorAll('[data-auto]').forEach(function (b) {
      b.addEventListener('click', function () {
        var wl = state.walls[+this.dataset.auto]; wl.extra = 0; wl.size = null; update(); buildFinishes();
      });
    });
  }

  function wallsString() {
    return state.walls.filter(function (w) { return w.w > 0 && w.h > 0; })
      .map(function (w) { return w.w + ' × ' + w.h + ' ' + state.unit; }).join('  |  ');
  }
  function fitString() {
    var w = state.walls[0];
    if (!w || !HAS_TILE) return '';
    var f = wallFit(w), pct = Math.round(Math.abs(f.stretch - 1) * 100);
    if (f.cropped) return 'stretched to the limit, edges cropped';
    return pct <= 1 ? 'exact fit' : 'stretched ' + pct + '% to fit the wall';
  }

  function addToCart() {
    var r = calc(), sk = scaleKey(), n = effScale();
    var btn = document.getElementById('CNCfgSubmit');
    var err = document.getElementById('CNCfgErr');
    if (r.panels < 1) return;
    btn.disabled = true; btn.textContent = tx('adding', 'Adding…'); err.textContent = '';

    var artwork = (IS_MURAL ? 'Mural — printed once across the wall'
      : (n === 1 ? 'Original (1:1) — printed once' : (sk.en || sk.label) + ' — repeats ' + n + ' × ' + n)) +
      (fitString() ? ', ' + fitString() : '');

    var items = Object.keys(r.groups).map(function (k) {
      var g = r.groups[k];
      return {
        id: g.variant.id,
        quantity: g.qty,
        properties: {
          'Wall': wallsString(),
          'Panel': PANEL_W + ' cm wide × ' + g.size.key,
          'Layout': r.cols + ' across × ' + r.rows + ' down — full coverage',
          'Artwork': artwork,
          '_cn_config': JSON.stringify({
            mode: CFG.renderMode, scale: IS_MURAL ? '1:1' : sk.key, repeats: n,
            unit: state.unit, walls: state.walls, panelW: PANEL_W, panelCm: g.size.cm,
            fit: fitString(), product: CFG.productId
          })
        }
      };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (j) {
          if (!res.ok) throw new Error(j.description || j.message || tx('err_add', 'Could not add to cart.'));
          return j;
        });
      })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
        });
        var badge = document.querySelector('.site-header__cart-count');
        if (badge) badge.textContent = cart.item_count;
        btn.textContent = tx('added', 'Added ✓');
        showChip(r);
        if (qtyIn) qtyIn.value = r.panels;
        setTimeout(function () { close(); btn.disabled = false; update(); }, 900);
      })
      .catch(function (e) {
        err.textContent = e.message || tx('err_add', 'Could not add to cart.');
        btn.disabled = false; update();
      });
  }

  function showChip(r) {
    var chip = document.getElementById('CNCfgChip');
    if (!chip) return;
    var sizes = Object.keys(r.groups).map(function (k) { return r.groups[k].qty + ' × ' + k; }).join(' + ');
    chip.hidden = false;
    chip.innerHTML = '<span><b>' + esc(r.panels > 1 ? tx('chip_other', '{n} panels', { n: r.panels }) : tx('chip_one', '{n} panel', { n: r.panels })) +
      '</b> · ' + esc(sizes) + '</span><button type="button" data-cnc-open>' + esc(tx('change', 'Change')) + '</button>';
    chip.querySelector('[data-cnc-open]').addEventListener('click', open);
  }

  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    update();
  }
  function close() {
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  modal.querySelectorAll('[data-cnc-close]').forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

  var trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'cnc-trigger';
  trigger.id = 'CNCfgTrigger';
  trigger.innerHTML =
    '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
    '<path d="M2 2h16v16H2z" stroke="currentColor" stroke-width="1.3"/>' +
    '<path d="M7.5 2v16M12.5 2v16" stroke="currentColor" stroke-width="1.1" opacity=".7"/>' +
    '</svg><span>' + esc(tx('open', 'Customise your wall')) + '</span>';
  trigger.addEventListener('click', open);

  var chip = document.createElement('div');
  chip.className = 'cnc-chip';
  chip.id = 'CNCfgChip';
  chip.hidden = true;

  atcRow.parentNode.insertBefore(chip, atcRow);
  atcRow.parentNode.insertBefore(trigger, atcRow);

  function syncTrigger() {
    var checked = form && form.querySelector('.cn-variant-radio:checked');
    var sample = checked && isSample(checked.value);
    trigger.hidden = !!sample;
    if (sample) { chip.hidden = true; return; }
    if (checked && TYPES.indexOf(checked.value) >= 0) { state.type = checked.value; buildFinishes(); update(); }
  }
  if (form) {
    form.querySelectorAll('.cn-variant-radio').forEach(function (rad) {
      rad.addEventListener('change', syncTrigger);
    });
  }

  document.querySelectorAll('#CNCfgViewSeg button').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('#CNCfgViewSeg button').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on'); state.view = b.dataset.view; update();
    });
  });
  document.querySelectorAll('#CNCfgUnits button').forEach(function (b) {
    b.addEventListener('click', function () {
      var to = b.dataset.u;
      if (state.unit === to) return;
      state.walls = state.walls.map(function (w) {
        var wc = toCm(w.w), hc = toCm(w.h);
        return to === 'in'
          ? { w: Math.round(wc / CM_IN * 10) / 10, h: Math.round(hc / CM_IN * 10) / 10, extra: w.extra, size: w.size }
          : { w: Math.round(wc), h: Math.round(hc), extra: w.extra, size: w.size };
      });
      state.unit = to;
      document.querySelectorAll('#CNCfgUnits button').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on');
      buildWalls(); update();
    });
  });
  document.getElementById('CNCfgPanels').addEventListener('change', function () { state.panels = this.checked; update(); });
  document.getElementById('CNCfgRuler').addEventListener('change', function () { state.ruler = this.checked; update(); });
  document.getElementById('CNCfgAddWall').addEventListener('click', function () {
    state.walls.push(state.unit === 'in' ? { w: 96, h: 102, extra: 0, size: null } : { w: 240, h: 260, extra: 0, size: null });
    buildWalls(); update();
  });
  document.getElementById('CNCfgSubmit').addEventListener('click', addToCart);

  buildScales(); buildFinishes(); buildWalls(); syncTrigger(); update();
})();